import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import {handleFieldChange} from "../../Utils";

class AdkCalculus extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            subidValues: [],
            partnerValues: [],
            params: [],
            paramsObj: {},
            report: [],
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
        this.loadAffids();
    }

    handleSubmit(filters) {
        this.setState({ isLoading: true });

        this.loadReport(filters);
    }

    loadAffids() {
        API.AdkFeeds.getIds()
            .then(affids => this.setState({ affidValues: affids }));
    }

    loadReport(filters) {
        API.AdkCalculus.get(filters).then(({ params, report }) => {
            const paramsObj = params.reduce((obj, param, index) => {
                obj[param] = index;

                return obj;
            }, {});
            const newState = { params, paramsObj, report, isLoading: false };

            this.setState(newState)
        });
    }

    getTable() {
        let { params, paramsObj, report } = this.state;

        if(report.length) {
            return <Table params={params} paramsObj={paramsObj} report={report} />;
        }

        return <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="ADK Calculus"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues}/>


                {this.getTable()}
            </Container>
        );
    }
}

export default AdkCalculus;



// WEBPACK FOOTER //
// ./src/scenes/AdkCalculus/index.js